import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import BlogAdmin from "./BlogAdmin";

const BlogAdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BlogAdmin />} />

      <Route path="*" element={<Navigate to="/blog" replace />} />
    </Routes>
  );
};

export default BlogAdminRoutes;
